import React from 'react'
import { Badge } from 'antd'
import PropTypes from 'prop-types'
import { THEME } from '../../../../core/constants'
import {
  SCRAPING_SESSION_VALIDATION_STATUSES,
  SCRAPING_SESSION_VALIDATION_COMPLETED,
  SCRAPING_SESSION_VALIDATION_ERROR,
  SCRAPING_SESSION_VALIDATION_IN_PROGRESS,
  SCRAPING_SESSION_VALIDATION_PENDING,
  IN_PROGRESS,
} from '../../../constants'

const backgroundColorByStatus = {
  [SCRAPING_SESSION_VALIDATION_PENDING]: THEME.colors.blue,
  [SCRAPING_SESSION_VALIDATION_IN_PROGRESS]: THEME.colors.yellow,
  [SCRAPING_SESSION_VALIDATION_COMPLETED]: THEME.colors.green,
  [SCRAPING_SESSION_VALIDATION_ERROR]: THEME.colors.red,
}

const ScrapingSessionValidationStatus = ({ status, scrapingStatus }) => {
  const validationStatus = SCRAPING_SESSION_VALIDATION_STATUSES[status]

  if (!validationStatus) return <Badge count="N/A" />

  const isPartial =
    status === SCRAPING_SESSION_VALIDATION_COMPLETED &&
    scrapingStatus === IN_PROGRESS

  return (
    <Badge
      count={isPartial ? 'Partial' : validationStatus.name}
      style={{
        backgroundColor: isPartial
          ? THEME.colors.orange
          : backgroundColorByStatus[status],
      }}
    />
  )
}

ScrapingSessionValidationStatus.propTypes = {
  status: PropTypes.string,
  scrapingStatus: PropTypes.string,
}

ScrapingSessionValidationStatus.defaultProps = {
  status: SCRAPING_SESSION_VALIDATION_PENDING,
  scrapingStatus: undefined,
}

export default ScrapingSessionValidationStatus
